import React from "react";
import styles from "styles/pages/HeatMapList.module.scss";
import { dateTimeFormat } from "services/utils";
import { Tooltip } from "@mui/material";
import asset from "json/assets";

const CourseMapListTableRowItem = ({
	course,
	onMapClick,
	onScorecardClick,
	onEditClick,
}) => {
	const isInactive = course.active === 0;
	const rowStyle = isInactive ? { color: "red" } : {};
	return (
		<tr key={course.id_course} id={String(course.id_courseInt)}>
			<td className={styles.name_cont} style={rowStyle}>
				{course.id_courseInt}
			</td>
			<td className={styles.name_cont} style={rowStyle}>
				{course.courseName}
				<div className={styles.city_box} style={rowStyle}>
					<p>
						{course.city || "-"}, {course.stateShort || "-"}
					</p>
				</div>
			</td>
			<td className={styles.city_cont} style={rowStyle}>
				{course.city}
			</td>
			<td className={styles.state_cont} style={rowStyle}>
				{course.stateShort || "--"}
			</td>
			<td className={styles.country_cont} style={rowStyle}>
				{course.countryFull}
			</td>
			<td className={styles.state_cont} style={rowStyle}>
				{course.id_course}
			</td>
			<td className={styles.state_cont} style={rowStyle}>
				{course.layoutHoles}
			</td>
			<td className={styles.one_meter_cont} style={rowStyle}>
				{course["1meterElevationAvailable"] === 1 ? "Yes" : "No"}
			</td>
			<td className={styles.state_cont} style={rowStyle}>
				{course.greenHeatmapAvailable}
			</td>
			<td className={styles.modified_cont} style={rowStyle}>
				{dateTimeFormat(course.courseModified)}
			</td>
			<td className={styles.action_cont}>
				<div className={styles.action_bar}>
					<Tooltip title="Mapping" arrow placement="top">
						<button onClick={() => onMapClick(course)}>
							<img src={asset.view} alt="Map" />
						</button>
					</Tooltip>
					<Tooltip title="Scorecard" arrow placement="top">
						<button onClick={() => onScorecardClick(course.id_courseInt)}>
							<img
								className={styles.scorecardIcon}
								src={asset.whiteScorecardIcon}
								alt="Scorecard"
							/>
						</button>
					</Tooltip>
					<Tooltip title="Info" arrow placement="top">
						<button onClick={(e) => onEditClick(e, course.id_courseInt)}>
							<img src={asset.pencilicon} alt="Edit" />
						</button>
					</Tooltip>
				</div>
			</td>
		</tr>
	);
};

export default CourseMapListTableRowItem;
